// src/pages/ProjectExample.jsx
import './ProjectPage.css'; // separate CSS for project pages



import HeartCalligraphy_img1 from '../../assets/images/HeartCalligraphy_img1.webp';
import HeartCalligraphy_img2 from '../../assets/images/HeartCalligraphy_img2.jpg';
import HeartCalligraphy_img3 from '../../assets/images/HeartCalligraphy_img3.jpg';
import HeartCalligraphy_img4 from '../../assets/images/HeartCalligraphy_img4.jpg';
import HeartCalligraphy_img5 from '../../assets/images/HeartCalligraphy_img5.png';
import HeartCalligraphy_img6 from '../../assets/images/HeartCalligraphy_img6.jpg';
import HeartCalligraphy_img7 from '../../assets/images/HeartCalligraphy_img7.jpg';
import HeartCalligraphy_img8 from '../../assets/images/HeartCalligraphy_img8.jpg';



function HeartCalligraphy() {
  return (
    <>


      <div className="project-page-wrapper">
        {/* Project title */}
        <h1 className="project-title">Heart Calligraphy: Let the Heart Lead the Brush. </h1>

        {/* Introduction text */}
        <p className="project-introduction">
        In traditional Chinese culture, calligraphy is seen as a silent reflection of the mind. A Chinese calligrapher believes that the mind leads the brush, and his goal is to vividly and honestly convey his mind on paper. 
        Inspired by this philosophy, we research how bio-data can be translated into a sensitive visual language in order to enhance self-awareness. Heart Calligraphy is a biofeedback installation in which the heart leads the brush. 
        Participants explore the physical, cognitive and emotional influences on their physiology, and the resulting prints are abstract portraits depicting the subconscious processes of the human body.
        </p>

        {/* Image */}
        <div className="project-image">
          <img src={HeartCalligraphy_img1} alt="1" />
        </div>

        {/* Details text */}
        <p className="project-details-text">
        Heart Calligraphy depicts heart rate variability (HRV) through the overall effect of an abstract drawing that is composed of arrayed lines and dots drawn by the Bio-Plotter. 
        Newly calculated HR data slightly adjust the pressure, pen downtime and path of pen movements. The friction between pen tip and paper can further magnify the variation of pen movements into lines of different lengths and intensities or dots of varying shapes and sizes.
        </p>

        {/* Another image */}
        <div className="project-image">
          <img src={HeartCalligraphy_img2} alt="HeartCalligraphy_img2" />
              <figcaption className="image-caption">
                The movement of the pen plotter is triggered by the user’s heart beat data. The plotter draws lines and dots on paper, creating abstract portraits that reflect the user’s physiological state. The more variable the heart rate, the more dynamic and expressive the resulting artwork.
            </figcaption>
        </div>

         <div className="project-image">
          <img src={HeartCalligraphy_img3} alt="HeartCalligraphy_img3" />
             <figcaption className="image-caption">
                An pulse sensor is used to capture the user’s heart beat data. The sensor is attached to the user’s finger, and it detects the pulse signal through light absorption. The captured data is then processed and mapped to control the pen plotter’s movement.
            </figcaption>
        </div>

        <div className="project-image">
          <img src={HeartCalligraphy_img4} alt="HeartCalligraphy_img4" />
               <figcaption className="image-caption">
                Every session of Heart Calligraphy is a unique experience, as the resulting artwork is influenced by the user’s physiological state, which can be affected by various factors such as emotions, thoughts and physical activity. The installation invites users to explore the connection between their inner world and the external expression, fostering self-awareness and mindfulness through the creative process.
            </figcaption>
        </div>


        {/* Further text */}

      <div className="project-image">
          <img src={HeartCalligraphy_img5} alt="HeartCalligraphy_img5" />
        </div>

       {/* Details text */}
        <p className="project-details-text">
            As a preliminary art exploration with pen plotter, we do not intend to draw sophisticated graphics. Instead, we make the plotter draw the basic elements in Chinese calligraphy, namely lines and dots. 
            In this project, four mapping methods have been implemented to discover the possibilities of interaction and the aesthetic impact: (1) position of the pen, (2) pressure of the pen, (3) speed of the pen and (4) the time of pen down. 
            Besides, we experimented with different types of pens and papers such as the fiber-tip pen (i.e. black marker), rotting pen, brush pen, tilt-tip brush pen, rollerball pen and charcoal.
        </p>

        <div className="project-image">
          <img src={HeartCalligraphy_img6} alt="HeartCalligraphy_img6" />
               <figcaption className="image-caption">
               This HeartCalligraphy was created on sketching paper with a charcoal stick. The charcoal stick is a traditional drawing tool that can produce rich textures and tones. 
               The charcoal stick drew lines of equal length in rows, but the pressure of the stick touching paper varied according to the user’s heart rate variability.
               The resulting artwork is an abstract portrait with 'blocks' of different shade, that reflects the changes of user’s the heart rate.
            </figcaption>
        </div>


        <div className="project-image">
          <img src={HeartCalligraphy_img7} alt="HeartCalligraphy_img7" />
               <figcaption className="image-caption">
               Each dot indicates one heartbeat. Heart rate data is mapped to pen-down time. The intensity of dots reflects the heart rate.
            </figcaption>
        </div>


        <div className="project-image">
          <img src={HeartCalligraphy_img8} alt="HeartCalligraphy_img8" />
               <figcaption className="image-caption">
                Heart rate data is mapped to pen pressure. The size and thickness of dots reflect the heart rate
            </figcaption>
        </div>


        {/* Details text */}
        <p className="project-details-text">
          Bio-data–driven art has become an important strand within contemporary artistic practice. Diverse forms of physiological data—such as brainwaves, heart rate, skin conductance, and respiration—have been incorporated into artworks to create deeply personal and psychophysiological aesthetic experiences. 
          Bio-data can both power interactive installations and take tangible form in physical media such as sculptures or paintings.
           This project contributes to the field of bio-data–driven art by transforming digital physiological signals into expressive visual artifacts. The varied effects produced by different brushes and inks translate data into an aesthetic language that invites artistic appreciation. 
           Although the representations may appear abstract, each painting retains a direct connection to the underlying heart rate data. Our work further highlights the importance of aesthetics in personal data visualization, 
           demonstrating how artistic interpretation can foster more meaningful and reflective engagement with one’s own bodily information.
        </p>
        

       <div className="project-video">
        <iframe
            src="https://player.vimeo.com/video/501280561"
            width="100%"
            height="450"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Heart Calligraphy Video"
        ></iframe>
        </div>



        {/* Footer: financing and partners */}
        <div className="project-footer">
         <p><strong>Publication: </strong>  <a href="https://doi.org/10.1162/leon_a_01772" target="_blank" rel="noopener noreferrer">  Biofeedback Painting: Let the Heart Lead the Brush. (Leonardo) </a></p>
          <p><strong>Project Partners:</strong>  <a href="https://www.rogierarents.nl/" target="_blank" rel="noopener noreferrer">Studio Rogier Arents</a></p>
          <p><strong>Exhibitions:</strong> Dutch Design Week, Eindhoven, NL (2015);   International Conference on Tangible, Embedded and Embodied Interaction (TEI), Eindhoven, NL (2016);   Next Up, Kazerne, Eindhoven, NL (2016);   Wanted Design, New York, USA (2016);   Maand van de grafiek, TU/e, Eindhoven NL (2017)</p>
        </div>
      </div>
    </>
  );
}

export default HeartCalligraphy;
